import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tooltip } from 'antd';
import React from 'react';

interface IProps {
  disabled?: boolean;
  onRemove: () => void;
  /** Labelled button (mobile) rather than the bare bin icon used in the desktop grid. */
  labelled?: boolean;
}

/** Removing a service always asks: its labour and parts go with it. */
export const RemoveServiceButton: React.FC<IProps> = ({ disabled, onRemove, labelled }) => (
  <Popconfirm
    title="Remove this service from the job?"
    description="Its labour and parts come off the job when you save."
    okText="Remove"
    okButtonProps={{ danger: true }}
    onConfirm={onRemove}
    disabled={disabled}
  >
    {labelled ? (
      <Button danger size="small" icon={<DeleteOutlined />} disabled={disabled}>
        Remove service
      </Button>
    ) : (
      // Below the button: above it, the tooltip covered the row's Print and Return parts buttons.
      <Tooltip placement="bottom" title={disabled ? undefined : 'Remove service'}>
        <Button type="text" danger icon={<DeleteOutlined />} disabled={disabled} />
      </Tooltip>
    )}
  </Popconfirm>
);
